import { useState } from "react";
import { saveMerchant } from "../Api/MerchantMaster";
import { Container, Form, Button, Row, Col } from "react-bootstrap";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Sample14 from "../Components/Logo";

const MerchantMaster = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const userId = userDetails?.userId;

  const [merchantData, setMerchantData] = useState({
    merchantCode: "",
    merchantName: "",
    groups: "",
    state: "",
    teamCode: "",
    contactPerson: "",
    address1: "",
    address2: "",
    mobileNumber: "",
    email: "",
    merchantType: ""
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setMerchantData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    try {
      // Prepare the data to match exactly what the backend expects
      const requestData = {
        merchantCode: merchantData.merchantCode,
        merchantName: merchantData.merchantName,
        groups: merchantData.groups,
        state: merchantData.state,
        teamCode: merchantData.teamCode,
        contactPerson: merchantData.contactPerson,
        address1: merchantData.address1,
        address2: merchantData.address2,
        mobileNumber: merchantData.mobileNumber,
        email: merchantData.email,
        merchantType: merchantData.merchantType
      };

      await saveMerchant(requestData, userId);
      toast.success(`🦄 Merchant Added Successfully`);
      
      // Reset form
      setMerchantData({
        merchantCode: "",
        merchantName: "",
        groups: "",
        state: "",
        teamCode: "",
        contactPerson: "",
        address1: "",
        address2: "",
        mobileNumber: "",
        email: "",
        merchantType: ""
      });
      
      navigate("/merchantMaster");
    } catch (error) {
      toast.error(`🦄 Error saving merchant: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
      <div className="main-content expand">
        <Container fluid className="fields-container">
          <h2 className="fields-title">Merchant Master</h2>

          {loading && (
            <div className="loading-overlay">
              <Sample14 />
            </div>
          )}

          <Form onSubmit={handleSubmit} className="fields-form">
            <Row>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Merchant Code <span className="text-red">**</span></Form.Label>
                  <Form.Control
                    type="text"
                    name="merchantCode"
                    value={merchantData.merchantCode}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Merchant Name <span className="text-red">**</span></Form.Label>
                  <Form.Control
                    type="text"
                    name="merchantName"
                    value={merchantData.merchantName}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Groups <span className="text-red">**</span></Form.Label>
                  <Form.Control
                    type="text"
                    name="groups"
                    value={merchantData.groups}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Merchant Type <span className="text-red">**</span></Form.Label>
                  <div>
                    <Form.Check
                      inline
                      label="Manufacturer"
                      name="merchantType"
                      type="radio"
                      id="manufacturer"
                      value="manufacturer"
                      checked={merchantData.merchantType === "manufacturer"}
                      onChange={handleChange}
                      required
                    />
                    <Form.Check
                      inline
                      label="Supplier"
                      name="merchantType"
                      type="radio"
                      id="supplier"
                      value="supplier"
                      checked={merchantData.merchantType === "supplier"}
                      onChange={handleChange}
                    />
                  </div>
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>State <span className="text-red">**</span></Form.Label>
                  <Form.Control
                    type="text"
                    name="state"
                    value={merchantData.state}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Team Code <span className="text-red">**</span></Form.Label>
                  <Form.Control
                    type="text"
                    name="teamCode"
                    value={merchantData.teamCode}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Contact Person <span className="text-red">**</span></Form.Label>
                  <Form.Control
                    type="text"
                    name="contactPerson"
                    value={merchantData.contactPerson}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={8}>
                <Form.Group className="mb-3">
                  <Form.Label>Address 1 <span className="text-red">**</span></Form.Label>
                  <Form.Control
                    type="text"
                    name="address1"
                    value={merchantData.address1}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Address 2</Form.Label>
                  <Form.Control
                    type="text"
                    name="address2"
                    value={merchantData.address2}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group className="mb-3">
                  <Form.Label>Mobile Number <span className="text-red">**</span></Form.Label>
                  <Form.Control
                    type="tel"
                    name="mobileNumber"
                    value={merchantData.mobileNumber}
                    onChange={handleChange}
                    required
                    pattern="[0-9]{10}"
                    title="Please enter a 10-digit mobile number"
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group className="mb-3">
                  <Form.Label>Email <span className="text-red">**</span></Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    value={merchantData.email}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>

            <div className="fields-btn-container">
              <Button
                variant="primary"
                type="submit"
                className="fields-submit"
                disabled={loading}
              >
                {loading ? "Saving..." : "Save Merchant"}
              </Button>
            </div>
          </Form>
        </Container>
      </div>
  );
};

export default MerchantMaster;